/* eslint-disable */
import { post, downloadFile } from "../../../http";

export interface IReportExportConfig {
  baseUrl: string;
  baseReportingUrl: string;
}

export interface IReportExportQuery {
  title: string;
  subtitle?: string;
  source: string;
  reportDefinition: {
    reportId: string;
    name: Record<number, string>;
    parameters: Record<string, string[] | string | null | undefined>;
  };
}

export class ReportExportService {
  protected _baseUrl: string;
  protected _baseReportingUrl: string;

  constructor(config: IReportExportConfig) {
    this._baseUrl = config.baseUrl;
    this._baseReportingUrl = config.baseReportingUrl;
  }

  private buildPayload(queries: IReportExportQuery[], onlyArrays: boolean = false): Record<string, any> {
    const payloads: any[] = [];
    for (const query of queries) {
      const parameters: Record<string, any>[] = [];

      for (const key of Object.keys(query.reportDefinition.parameters)) {
        const value = query.reportDefinition.parameters[key];
        parameters.push({
          id: key,
          type: 1,
          multiplicityType: Array.isArray(value) ? 2 : 1,
          value: !onlyArrays || Array.isArray(value) ? value : [value],
        });
      }
      payloads.push({
        title: query.title,
        subtitle: query.subtitle,
        source: query.source,
        reportDefinition: {
          id: query.reportDefinition.reportId,
          names: query.reportDefinition.name,
          parameters,
        },
      });
    }

    return payloads;
  }

  private async download(res: Response) {
    const blob = await res.blob();
    const filename = res.headers
      .get("Content-Disposition")!
      .split("; ")
      .find((x) => x.includes("filename*=UTF-8''"))!
      .split("''")[1];
    downloadFile(blob, decodeURIComponent(filename));
  }

  xlsx = async (queries: IReportExportQuery[]) => this.export("xlsx", queries);

  pptx = async (queries: IReportExportQuery[]) => this.export("pptx", queries);

  protected async export(uri: string, queries: IReportExportQuery[]) {
    const reportV2Ids = [
      "slide-36",
      "slide-35",
      "slide-34",
      "slide-33",
      "slide-32",
      "slide-31",
      "slide-24",
      "slide-24-ape",
      "slide-23",
      "slide-21",
      "slide-20",
      "slide-18",
      "slide-17",
      "slide-16",
      "slide-15",
      "slide-13",
      "slide-12",
      "stocks",
      "aquarium-crop-value",
      "aquarium-production",
      "aquarium-production-ape",
      "aquarium-area",
      "aquarium-area-ape",
      "world-overview-major-crops",
      "world-overview-major-crops-ape",
      "world-overview-major-crops-forecast",
      "world-overview-major-crops-forecast-ape",
      "annual-crop-area",
      "annual-crop-area-ape",
      "annual-crop-production",
      "annual-crop-production-ape",
      "ap-annual-area",
      "ap-annual-area-ape",
      "ap-annual-production",
      "ap-annual-production-ape",
      "lead-countries-major-crops-population",
      "lead-countries-major-crops-population-forecast",
      "lead-countries-major-crops",
      "lead-countries-major-crops-ape",
      "lead-countries-major-crops-forecast",
      "lead-countries-major-crops-forecast-ape",
    ];
    const redirectOnV2 =
      uri === "xlsx" && queries.length === 1 && reportV2Ids.includes(queries[0].reportDefinition.reportId);
    const res = await post(
      `${redirectOnV2 ? this._baseReportingUrl : this._baseUrl}/reporting/export/${uri}`,
      this.buildPayload(queries, redirectOnV2),
      {
        headers: {
          Accept: "*/*",
        },
      },
    );
    this.download(res);
  }
}
